module.exports = __webpack_public_path__ + "img/cup4.a0d116df.png";